

















import {Component, Vue} from "vue-property-decorator";
import TDSModal from "@/components/partials/TDSModal/TDSModal.vue";
import TDSButton from "@/components/common/TDSButton.vue";

@Component({
    components: {TDSModal, TDSButton}
})
export default class LogoutConfirmModal extends Vue {
    private isLoading: boolean = false;

    private async logout(): Promise<void> {
        this.isLoading = true;
        try {
            await this.$authenticator.signOut();
        } catch (e) {
            this.$toastr.error(this.$t("navigation.errors.logout"), e);
            this.isLoading = false;
        }
    }
}
